<template>
    <div>
        <header class="page-header">
            <h2><a href=""></a></h2>
            <ol class="breadcrumbs">
                <li class="active">
                    <span>Administración de pagos</span>
                </li>
            </ol>
            <div class="right-wrapper pull-right">
                <el-button type="primary" class="mt-2 mr-2"
                    @click="showDialog = true"
                >
                    <i class="fa fa-plus-circle"></i> Nueva orden de pago
                </el-button>
            </div>
        </header>
        <!-- info pagos -->
        <div class="row">
            <template v-if="!summary_payments.length">
                <CardLoading v-for="i in 4" :key="i" />
            </template>
            <template v-else>
                <Card v-for="(summary, index) in summary_payments"
                    :key="index"
                    :total="summary.total"
                    :title="summary.title"
                    :icon="summary.icon"
                />
            </template>
        </div>
        <!-- listado de pagos -->
         <div class="row mt-4">
            <div class="col-12">
                <el-card>
                    <!-- filtros -->
                    <div class="row">
                        <div class="col">
                            <el-button
                                @click="showfilters = !showfilters"
                            >
                                {{ showfilters ? 'Ocultar' : 'Mostrar' }} filtros
                            </el-button>
                        </div>
                    </div>
                    <div class="row" v-if="showfilters">
                        <div class="col-12 col-md-6 col-lg-5">
                            <div class="form-group">
                                <label class="control-label">Cliente</label>
                                <el-select v-model="params.client_id" 
                                    placeholder="Seleccione un cliente"
                                    filterable
                                    remote
                                    :remote-method="searchRemoteClients"
                                    :loading="loading_search"
                                    loading-text="Bucando clientes..."
                                    clearable
                                >
                                    <el-option v-for="(client, index) in clients"
                                        :key="index"
                                        :value="client.id"
                                        :label="client.name"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label class="control-label">Estado</label>
                                <el-select v-model="params.state" placeholder="Seleccionar"
                                    clearable
                                >
                                  <el-option label="Pagado" value="P"></el-option>
                                  <el-option label="Pendiente" value="E"></el-option>
                                  <el-option label="Vencido" value="V"></el-option>
                                  <el-option label="Anulado" value="A"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-2">
                            <div class="form-group">
                                <label class="control-label">Fecha de inicio de gracia</label>
                                <el-date-picker v-model="params.start_date" placeholder="Fecha de inicio"
                                    type="date"
                                    clearable
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-2">
                            <div class="form-group">
                                <label class="control-label">Fecha de fin de gracia</label>
                                <el-date-picker v-model="params.end_date" placeholder="Fecha de inicio"
                                    type="date"
                                    clearable
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <el-button type="primary" @click="getRecords"
                                :loading="loading_filters"
                                icon="el-icon-search"
                            >
                                Filtrar
                            </el-button>
                            <el-button class="ml-2" @click="resetFilters"
                                :disabled="loading_filters"
                                icon="el-icon-refresh-right"
                            >
                                Limpiar filtros
                            </el-button>
                        </div>
                    </div>

                    <!-- Resumen pagos x cliente en especifico -->
                    <div class="row mt-3 mb-1" v-if="data_client" v-loading="loading_summary_client">
                        <div class="col-12">
                            <CardClient :data_client="data_client"
                                @reloadData="reloadData"
                                @reloadInfoClient="getSummaryClient"
                            />
                        </div>
                    </div>

                    <!-- Tabla -->
                    <Table
                        ref="tablePayments"
                        v-loading="loading_records"
                        class="mt-3"
                        @sort-change="handleSortChange"
                        :empty="!records.length"
                    >
                        <tr slot="tbody" v-for="(row, index) in records"
                            :key="index"
                        >
                            <td class="text-center">
                                <strong>{{ row.nro }}</strong>
                            </td>
                            <td>
                                <a :href="formatUrl(row.hostname)" target="_blank" class="text-primary">{{ row.hostname }}</a><br>
                                <span>{{ row.client_name }}</span><br>
                                <span>{{ row.client_document }}</span><br>
                                <span>{{ row.concept }}</span>
                            </td>
                            <td class="text-center">
                                <el-input v-model="row.payment"
                                    type="number"
                                    precision="2"
                                    :min="0"
                                    size="small"
                                    step="0.01"
                                    :disabled="row.state === 'A' || row.state === 'P'"
                                    @change="updateColumn('payment', row)"
                                    style="width: 180px;"
                                >
                                    <template slot="prepend">S/.</template>
                                </el-input>
                            </td>
                            <td class="text-center">
                                <el-date-picker v-model="row.date_of_due_input"
                                    type="date"
                                    :clearable="false"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    @change="updateColumn('date_of_due', row)"
                                    :disabled="enableDatePicker(row)"
                                    style="width: 180px;"
                                ></el-date-picker>
                            </td>
                            <td class="text-center">
                                <el-date-picker v-model="row.date_of_payment"
                                    @change="updateColumn('date_of_payment', row)"
                                    :disabled="enableDatePicker(row)"
                                    type="date"
                                    :clearable="false"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    style="width: 180px;"
                                ></el-date-picker>
                            </td>
                            <td class="text-center">
                                <el-tag :type="getTypeState(row.state)">
                                    {{ getNameState(row.state) }}
                                </el-tag>
                                <template v-if="row.state === 'P'">
                                    <br>
                                    <span>{{ row.date_of_payment_real }}</span>
                                </template>
                            </td>
                            <td class="text-center">
                                <template v-if="row.qty_notification > 0">
                                    <el-tag>
                                        {{ row.qty_notification }}
                                    </el-tag>
                                    <br>
                                </template>
                                {{ row.date_of_notifications }}
                            </td>
                            <td class="text-center">
                                <template v-if="row.file">
                                            <div class="d-flex align-items-center">
                                                <el-button type="success" plain
                                                    size="small"
                                                    round
                                                    @click="donwloadFile(row.id)"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11.5V20m0 0l3-3m-3 3l-3-3M8 7.036a3.5 3.5 0 0 1 1.975.99M17.5 14c1.519 0 2.5-1.231 2.5-2.75a2.75 2.75 0 0 0-2.016-2.65A5 5 0 0 0 8.37 7.108a3.5 3.5 0 0 0-1.87 6.746"/></svg>
                                                </el-button>
                                                <el-button type="danger" plain
                                                    size="small"
                                                    round
                                                    @click="deleteFile(row.id)"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M10 2.25a.75.75 0 0 0-.75.75v.75H5a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5h-4.25V3a.75.75 0 0 0-.75-.75zm0 8.4a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75m4.75.75a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0z"/><path fill="currentColor" fill-rule="evenodd" d="M5.991 7.917a.75.75 0 0 1 .746-.667h10.526a.75.75 0 0 1 .746.667l.2 1.802c.363 3.265.363 6.56 0 9.826l-.02.177a2.85 2.85 0 0 1-2.44 2.51a27 27 0 0 1-7.498 0a2.85 2.85 0 0 1-2.44-2.51l-.02-.177a44.5 44.5 0 0 1 0-9.826zm1.417.833l-.126 1.134a43 43 0 0 0 0 9.495l.02.177a1.35 1.35 0 0 0 1.157 1.191c2.35.329 4.733.329 7.082 0a1.35 1.35 0 0 0 1.157-1.19l.02-.178c.35-3.155.35-6.34 0-9.495l-.126-1.134z" clip-rule="evenodd"/></svg>
                                                </el-button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <el-upload
                                                class="upload-demo"
                                                :headers="headers"
                                                :action="`/${resource2}/upload-direct`"
                                                :data="{'index': index, 'client_id': row.client_id, 'client_payment_id': row.id}"
                                                :multiple="false"
                                                :limit="1"
                                                :on-success="successUploadDirect"
                                                :show-file-list="false"
                                            >
                                                <el-button
                                                    slot="trigger" size="small"
                                                    type="primary"
                                                >
                                                    Seleccionar archivo
                                                </el-button>
                                                <div slot="tip" class="el-upload__tip" v-if="row.file">
                                                    Un archivo cargado
                                                </div>
                                            </el-upload>
                                        </template>
                            </td>
                            <td class="text-center">
                                <el-checkbox 
                                    :value="row.verify_payment"
                                    @change="(val) => updateVerifyPayment(row, val)"
                                ></el-checkbox>
                            </td>
                            <td class="text-center"> <!--acciones pagos-->
                                <template v-if="row.state === 'E' || row.state === 'V'">
                                    <el-dropdown trigger="click">
                                        <span class="el-dropdown-link">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 26"><g fill="currentColor"><g transform="translate(3 3)"><circle cx="10" cy="15" r="2"/><circle cx="10" cy="10" r="2"/><circle cx="10" cy="5" r="2"/></g><path fill-rule="evenodd" d="M13 24c6.075 0 11-4.925 11-11S19.075 2 13 2S2 6.925 2 13s4.925 11 11 11m0 2c7.18 0 13-5.82 13-13S20.18 0 13 0S0 5.82 0 13s5.82 13 13 13" clip-rule="evenodd"/></g></svg>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                @click.native.prevent="sendNotification(row)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="m20.34 9.32l-14-7a3 3 0 0 0-4.08 3.9l2.4 5.37a1.06 1.06 0 0 1 0 .82l-2.4 5.37A3 3 0 0 0 5 22a3.14 3.14 0 0 0 1.35-.32l14-7a3 3 0 0 0 0-5.36Zm-.89 3.57l-14 7a1 1 0 0 1-1.35-1.3l2.39-5.37a2 2 0 0 0 .08-.22h6.89a1 1 0 0 0 0-2H6.57a2 2 0 0 0-.08-.22L4.1 5.41a1 1 0 0 1 1.35-1.3l14 7a1 1 0 0 1 0 1.78"/></svg>
                                                Notificar
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                @click.native.prevent="pay(row)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"><path d="M21 7v-.63c0-1.193 0-1.79-.158-2.27a3.05 3.05 0 0 0-1.881-1.937C18.493 2 17.914 2 16.755 2h-9.51c-1.159 0-1.738 0-2.206.163a3.05 3.05 0 0 0-1.881 1.936C3 4.581 3 5.177 3 6.37V15m18-4v9.374c0 .858-.985 1.314-1.608.744a.946.946 0 0 0-1.284 0l-.483.442a1.657 1.657 0 0 1-2.25 0a1.657 1.657 0 0 0-2.25 0a1.657 1.657 0 0 1-2.25 0a1.657 1.657 0 0 0-2.25 0a1.657 1.657 0 0 1-2.25 0l-.483-.442a.946.946 0 0 0-1.284 0c-.623.57-1.608.114-1.608-.744V19"/><path stroke-linejoin="round" d="m9.5 10.4l1.429 1.6L14.5 8"/><path d="M7.5 15.5H9m7.5 0H12"/></g></svg>
                                                Pagar
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                @click.native.prevent="cancel(row)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><g fill="none"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m2.829 3.757a1 1 0 0 1 1.497 1.32l-.083.095l-7.071 7.07a1 1 0 0 1-1.498-1.32l.083-.094l7.072-7.07Z"/></g></svg>
                                                Anular
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                v-if="!row.qty_notification"
                                                @click.native.prevent="deletepayment(row)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M7.616 20q-.667 0-1.141-.475T6 18.386V6h-.5q-.213 0-.356-.144T5 5.499t.144-.356T5.5 5H9q0-.31.23-.54t.54-.23h4.46q.31 0 .54.23T15 5h3.5q.213 0 .356.144t.144.357t-.144.356T18.5 6H18v12.385q0 .666-.475 1.14t-1.14.475zM17 6H7v12.385q0 .269.173.442t.443.173h8.769q.269 0 .442-.173t.173-.442zm-6.335 10.856q.143-.144.143-.356v-8q0-.213-.144-.356T10.307 8t-.356.144t-.143.356v8q0 .213.144.356q.144.144.356.144q.213 0 .357-.144m3.384 0q.143-.144.143-.356v-8q0-.213-.144-.356Q13.904 8 13.692 8q-.213 0-.357.144t-.143.356v8q0 .213.144.356t.357.144t.356-.144M7 6v13z"/></svg>
                                                Eliminar
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                                <template v-else>
                                    Sin acciones
                                </template>
                            </td>
                        </tr>
                    </Table>

                    <el-pagination
                        v-if="!loading_records"
                        :total="pagination.total"
                        :current-page.sync="pagination.current_page"
                        :page-size="pagination.per_page"
                        @current-change="getData"
                        layout="total, prev, pager, next"
                    ></el-pagination>
                </el-card>
            </div>
        </div>

        <Form
            :showDialog.sync="showDialog"
            @registered="loadData"
        />
    </div>
</template>

<script>
    import CardLoading from './components/card-loading.vue'
    import Card from './components/card.vue'
    import Form from './components/form.vue'
    import CardClient from './components/card-client.vue'
    import Table from './components/table.vue'
    import { deletable } from '../../../mixins/deletable'

    export default {
        components: { CardLoading, Card, Form, CardClient, Table },
        mixins: [deletable],
        data() {
            return {
                resource: 'client-payments',
                resource2: 'client_payments',
                loading_records: false,
                params: {
                    page: 1,
                    sort_by: null,
                    sort_order: null,
                    start_date: null,
                    end_date: null,
                    state: null,
                    client_id: null
                },
                summary_payments: [],
                records: [],
                pagination: {},
                showfilters: false,
                showDialog: false,
                clients: [],
                loading_search: false,
                timer: null,
                loading_filters: false,
                loading_summary_client: false,
                data_client: null,

                headers: headers_token
            }
        },

        async created() {
            await this.loadData()
            await this.getClients()
        },

        methods: {
            async getInfoPayment() {
                const { data } = await this.$http.get(`/${this.resource}/summary`)
                if (data.success) {
                    this.summary_payments = data.data
                }
            },

            async getData(page = 1) {
                try {
                    this.loading_records = true
                    this.params.page = page
                    const { data } = await this.$http.get(`/${this.resource}/data-records?${this.getparams()}`)
                    if (data.success) {
                        this.records = data.data
                        this.pagination = data.meta
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    // this.$message.error(error.message)
                } finally {
                    this.loading_records = false
                    this.loading_filters = false
                }
            },

            async handleSortChange({sort_by, sort_order}) {
                this.params.sort_by = sort_by
                this.params.sort_order = sort_order
                this.pagination.current_page = 1
                await this.getData(1)
            },

            getparams() {
                const params = {}
                Object.keys(this.params).forEach(key => {
                    if (this.params[key]) {
                        params[key] = this.params[key]
                    }
                })
                return Object.keys(params).length > 0 ? `${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}` : ''
            },

            getTypeState(state) {
                if (state === 'E') {
                    return 'warning'
                }
                if (state === 'P') {
                    return 'success'
                }
                if (state === 'V') {
                    return 'danger'
                }
                return 'info'
            },

            getNameState(state) {
                if (state === 'E') {
                    return 'Pendiente'
                }
                if (state === 'P') {
                    return 'Pagado'
                }
                if (state === 'V') {
                    return 'Vencido'
                }
                return 'Anulado'
            },

            sendNotification(row) {
                this.$confirm('¿Está seguro de querer enviar la notificación?', 'Warning', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.post('/client-payments/sendNotification', row)
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.getData()
                            this.close()
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        
                    }
                })
                .catch(() => {})
            },

            pay(row) {
                this.$confirm('¿Está seguro de confirmar el pago?', 'Warning', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.get(`/client_payments/cancel_payment/${row.id}`)
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.loadData()
                            await this.getSummaryClient()
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        if (error.response) {
                            let errors = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(errors)
                        }
                    }
                })
                .catch(() => {})
            },

            async cancel(row) {
                this.$confirm('¿Está seguro de anular el pago?', 'Warning', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.post(`/${this.resource}/change-state/${row.id}`, {
                            state: 'A'
                        })
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.loadData()
                            await this.getSummaryClient()
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        this.$message.error(error.message)
                    }
                })
                .catch(() => {})
            },

            async deletepayment(row) {
                this.destroy(`/client_payments/${row.id}`).then(async () => {
                    await this.loadData()
                    await this.getSummaryClient()
                })
            },

            formatUrl(url) {
                const protocol = location.protocol
                return `${protocol}//${url}`
            },

            async loadData() {
                await this.getInfoPayment()
                await this.getData()
            },

            async updateColumn(column, row) {
                let value = null
                if(column === 'payment') {
                    value = row.payment
                } if (column === 'date_of_payment') {
                    value = row.date_of_payment
                } else {
                    value = row.date_of_due_input
                }
                const sendData = {
                    id: row.id,
                    column,
                    value
                }
                try {
                    const { data } = await this.$http.post(`/${this.resource}/updateColumn`, sendData)
                    if (data.success) {
                        this.$message.success(data.message)
                        await this.loadData()
                        await this.getSummaryClient()
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    
                }
            },

            async getClients(param = null) {
                try {
                    const { data } = await this.$http.post(`/${this.resource}/clients`, {
                        param: param
                    })
                    if (data.success) {
                        this.clients = data.data
                    }
                } catch (error) {
                    this.$message.error(error.response.data.message)
                }
            },

            searchRemoteClients(input) {
                this.loading_search = true
                clearTimeout(this.timer)
                this.timer = setTimeout(async () => {
                    await this.getClients(input)
                    this.loading_search = false
                }, 100)
            },

            async getRecords() {
                this.loading_filters = true
                this.params.sort_by = null
                this.params.sort_order = null
                this.$refs.tablePayments.resetSort()
                this.pagination.current_page = 1
                await this.getData(1)
                await this.getSummaryClient()
            },

            async resetFilters() {
                this.params.page = 1,
                this.params.sort_by = null,
                this.params.sort_order = null,
                this.params.start_date = null,
                this.params.end_date = null,
                this.params.state = null,
                this.params.client_id = null
                this.data_client = null
                this.$refs.tablePayments.resetSort()
                await this.getData(1)
            },

            async getSummaryClient() {
                try {
                    this.loading_summary_client = true
                    const { data } = await this.$http.post(`/${this.resource}/summary-client`, {
                        client_id: this.params.client_id,
                        start_date: this.params.start_date,
                        end_date: this.params.end_date
                    })
                    if (data.success) {
                        this.data_client = data.data
                    }
                } catch (error) {
                    
                } finally {
                    this.loading_summary_client = false
                }
            },

            async reloadData() {
                await this.loadData()
                await this.getSummaryClient()
            },

            enableDatePicker(row) {
                return row.state === 'A' || row.state === 'P'
            },
            async updateVerifyPayment(row, value) {
                try {
                    const { data } = await this.$http.post('/client-payments/updateColumn', {
                        id: row.id,
                        column: 'verify_payment',
                        value: value
                    })
                    if (data.success) {
                        row.verify_payment = value
                        this.$message.success("Datos Actualizados correctamente")
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    this.$message.error('Error al actualizar')
                }
            },
            async successUploadDirect(response) {
                if (response.success) {
                    this.$message.success(response.message)
                    await this.getData()
                } else {
                    this.$message.error(response.message)
                }
            },
            async donwloadFile(id) {
                window.open(`/${this.resource2}/download/${id}`, '_blank')
            },
            deleteFile(id) {
                this.$confirm('¿Seguro de eliminar el archivo?', 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.post(`/${this.resource2}/remove/${id}`)
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.getData()
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        this.$message.error(error.response.data.message || 'Error al realizar la operación')
                    }
                })
                .catch(() => { })
            }

        },
    }
</script>

<style>
    .el-dropdown-link {
        cursor: pointer;
    }
    .custom-content-item {
        display: flex;
        align-items: center;
        gap: 3px;
    }
    .el-table .text-center .cell {
        text-align: center;
    }
    
</style>


// WEBPACK FOOTER //
// resources/js/views/system/payments/index.vue